import { render } from "./ViewDocumentModal.vue?vue&type=template&id=6fb4e320"
import script from "./ViewDocumentModal.vue?vue&type=script&lang=js"
export * from "./ViewDocumentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__